import { CreateLancementPage } from "@features/production/components/CreateLancementPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FilePlus } from "lucide-react";
import { z } from "zod";

const createSearchSchema = z.object({
  of: z.coerce.number().optional(),
});

export const Route = createFileRoute("/_app/production/lancements/create")({
  validateSearch: createSearchSchema,
  loader: requirePermission(PERMISSIONS.PRODUCTION.LANCEMENTS.CREATE),
  staticData: {
    title: "Nouveau lancement",
    icon: FilePlus,
    permission: PERMISSIONS.PRODUCTION.LANCEMENTS.CREATE,
    section: "App",
    showInBreadcrumb: true,
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { of } = Route.useSearch();
  return <CreateLancementPage initialOfId={of} />;
}
